var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('VueFaqAccordion',{attrs:{"items":_vm.questions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }